import {
  SITE_NAME,
  SITE_URL,
  SITE_TAGLINE,
  DEFAULT_DESCRIPTION,
  SUPPORT_EMAIL,
  FAQ_ITEMS,
  SITE_ICON_URL,
  absoluteUrl,
} from '../../config/site';

export function getLandingStructuredData() {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: SITE_ICON_URL,
      description: DEFAULT_DESCRIPTION,
      email: SUPPORT_EMAIL,
      areaServed: 'IN',
      knowsAbout: [
        'Desi Hip-Hop',
        'Indian Hip-Hop',
        'Music collaboration',
        'Beat production',
        'Rap verses',
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
      description: DEFAULT_DESCRIPTION,
      inLanguage: 'en-IN',
      about: {
        '@type': 'Thing',
        name: 'Desi Hip-Hop (DHH)',
        description: 'Hip-hop music from India and the South Asian diaspora.',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: SITE_NAME,
      url: SITE_URL,
      applicationCategory: 'MusicApplication',
      operatingSystem: 'Web',
      description: DEFAULT_DESCRIPTION,
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'INR',
      },
      featureList: [
        'Upload beats',
        'Record rap verses in the browser',
        'Discover Desi Hip-Hop artists',
        'Vote on beats and verses',
        'Collaborate by Indian state and role',
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQ_ITEMS.map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ];
}

export const LANDING_SEO = {
  title: SITE_TAGLINE,
  description: DEFAULT_DESCRIPTION,
  path: '/',
  keywords:
    'DHH, Desi Hip Hop platform, Indian hip hop collaboration, upload beats India, record rap verses online, DHH Collab',
};

export { absoluteUrl };
